import React, { useCallback, useEffect, useState } from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import type { Style } from "@react-pdf/types";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import { DEBUG_RESUME_PDF_FLAG } from "lib/constants";
import { DEFAULT_FONT_COLOR } from "lib/redux/settingsSlice";
import { useAppSelector } from "lib/redux/hooks";
import { selectUserProfilePhoto } from "lib/redux/uiSlice";
import { handleClick } from "lib/utils/navigator";

export const TemplateTwentyPDFSection = ({
  themeColor,
  heading,
  style = {},
  children,
}: {
  themeColor?: string;
  heading?: string;
  style?: Style;
  children: React.ReactNode;
}) =>{
  const handleClickCallback = useCallback(() => handleClick(heading), [heading]);
  return (
  <div
  onClick={handleClickCallback}
    style={{
      ...styles.flexCol,
      gap: spacing["2"],
      marginTop: spacing["5"],
      cursor:"pointer"
      // ...style,
    }}
  >
    {heading && (
      <View style={{ ...styles.flexCol, gap: spacing["1"] }}>
        <Text
          style={{
            fontWeight: "bold",
            letterSpacing: "0.3pt", // tracking-wide -> 0.025em * 12 pt = 0.3pt
            color: themeColor || DEFAULT_FONT_COLOR,
          }}
          debug={DEBUG_RESUME_PDF_FLAG}
        >
          {heading}
        </Text>
        {themeColor && (
          <View
            style={{
              height: "1.25pt",
              width: "100%",
              backgroundColor: "black",
              marginRight: spacing["3.5"],
            }}
            debug={DEBUG_RESUME_PDF_FLAG}
          />
        )}
      </View>
    )}
    {children}
  </div>
)};

export const ProfileImage = ({
  src,
  alt,
  style = {},
}: {
  src: string;
  alt: string;
  style?: Style;
}) => {
  const [userProfilePhoto, setUserProfilePhoto] = useState<string | null>();
  // const pp = useAppSelector(selectUserProfilePhoto);
  useEffect(() => {
    setUserProfilePhoto(localStorage.getItem("profile-photo"));
    // console.log("userProfilePhoto", userProfilePhoto);
    // console.log("src", src);
  }, [src]);
  return (
    <View
      style={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        ...style,
      }}
    >
      {src && (
        <Image
          src={src}
          style={{
            width: "120px",
            height: "130px",
            marginLeft: "auto",
          }}
        />
      )}
      <img
        src={src}
        style={{
          width: "120px",
          height: "130px",
          position: "absolute",
          right: "0",
        }}
      />
    </View>
  );
};
